import React, { Component } from 'react';
import { ReactSVG } from 'react-svg';

import './SideBarMenu.scss';
import SidebarMenuItem from './components/SidebarMenuItem';
import SearchBarMenu from './components/SearchBarMenu';
import LogoSvgIcon from '../../../assets/common/svg/logo.svg'

class SidebarMenu extends Component {
  state = {
    searchText: '',
  };

  handleChangeSearchText = (searchText) => {
    this.setState({
      searchText,
    });
  };

  render() {
    const { searchText } = this.state;

    return (
      <div className="page-sidebar navbar-collapse">
        <div className="page-sidebar-header">
          <ReactSVG
            aria-hidden="true"
            src={LogoSvgIcon}
            wrapper="span"
            beforeInjection={(svg) => {
                svg.setAttribute('style', `width: 158px;height:42px;margin: 0 0 0 15px;`)
              }}
          />
        </div>
        <ul className="page-sidebar-menu">
          <SearchBarMenu
            searchText={searchText}
            onChangeSearchText={this.handleChangeSearchText}
          />
          <SidebarMenuItem searchText={searchText} />
        </ul>
      </div>
    );
  }
}

export default SidebarMenu;



// WEBPACK FOOTER //
// ./foody/src/layout/components/SidebarMenu/SidebarMenu.jsx